import {createApp} from 'vue'
import Overlay from './Overlay.vue'
import handleComponentProps from 'foundation/js/utils/handleComponentProps'

const el = '.be-component--overlay'

export default function(Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((OverlayDOM) => {
            handleComponentProps(Overlay, OverlayDOM)

            if (OverlayDOM.dataset.overlayType) {
                const overlayData = {
                    overlayType: OverlayDOM.dataset.overlayType,
                    titleText: OverlayDOM.dataset.titleText,
                    content: {
                        htmlString: OverlayDOM.querySelector('.be-overlay__content').innerHTML
                    }
                }
    
                console.log("testing",overlayData)
            }

            const component = createApp(Overlay).use(Store)
            component.mount(OverlayDOM)
        })
    }
}